import { useEffect, useState } from "react";
import { Button, Input } from "reactstrap";

import RichTextEditorV2 from "../../../../components/CRM/RichTextEditorV2";
import useCustomPrompt from "../../../../api/api-hooks/brie/useCustomPrompt";
import { GeneratedText } from "./EmailGenerator";

export default function TranslateText({
  providedText,
  providedStateValue,
  providedStateSetter,
}: {
  providedText?: string;
  providedStateValue: string;
  providedStateSetter: React.Dispatch<React.SetStateAction<string>>;
}) {
  const [richText, setRichText] = useState("");
  const [language, setLanguage] = useState("");
  const { generateText, generating } = useCustomPrompt();

  useEffect(() => {
    if (providedText) {
      setRichText(providedText);
    }
  }, [providedText]);

  return (
    <div>
      <h4>What do you want to translate?</h4>
      <RichTextEditorV2
        isEditing={true}
        value={richText}
        onChange={setRichText}
        loading={false}
        placeholder={"Enter you text here"}
        useBrie={false}
      />
      <h4 className="mt-4">Language</h4>
      <Input
        placeholder="Enter the language you want to translate to"
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        bsSize="sm"
      />
      <div className="d-flex justify-content-end mt-4">
        <Button
          color="primary"
          onClick={onTranslate}
          disabled={!richText.length || !language || generating}
          size="sm"
        >
          {generating ? "Translating..." : "Translate"}
        </Button>
      </div>
      {providedStateValue && (
        <GeneratedText
          title="Generated Text:"
          text={providedStateValue}
          isRichText
          copyable={false}
        />
      )}
    </div>
  );

  function onTranslate() {
    generateText({
      payload: {
        description: `Translate the following rich text to ${language}. 
                      Maintain all html tags and rich text formatting.
                      Here is the text: ${richText}`,
      },
      onSuccess: providedStateSetter,
    });
  }
}
